export enum AIAssistantMutationTypes {
  SET_CONVERSATION_ACTIVE_ID = 'SET_CONVERSATION_ACTIVE_ID',
  SET_CONVERSATION_MESSAGES_PENDING = 'SET_CONVERSATION_MESSAGES_PENDING',
  SET_CONVERSATIONS_PENDING = 'SET_CONVERSATIONS_PENDING',
  SET_PANE_OPENED = 'SET_PANE_OPENED',
  SET_POST_PROMPT_PENDING = 'SET_POST_PROMPT_PENDING',
  SET_CREDITS = 'SET_CREDITS',
  SET_CREDITS_PENDING = 'SET_CREDITS_PENDING',
  SET_CREDITS_REMAINING = 'SET_CREDITS_REMAINING',
}
